import { Component } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import { TranslatePipe } from 'src/app/shared/translate/translate.pipe';
import { ServiceLocator } from 'src/app/services/locator.service';
import { Util } from 'src/app/services/util.service';
import { TranslationService } from 'src/app/services/translation.service';
import { Config } from 'src/app/classes/Config';
import { User } from 'src/app/classes/User';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { DOCUMENT } from '@angular/common';
import { Direction } from '@angular/cdk/bidi/directionality';
import { Title } from '@angular/platform-browser';
import { Right } from 'src/app/classes/Right';
@Component({
  selector: 'app-base',
  templateUrl: './base.component.html'
})
export class BaseComponent {

  public translatePipe: TranslatePipe;
  public util: Util;
  public translationService: TranslationService;
  public authorizationService: AuthorizationService;
  public userLocale: string;
  public direction: string;
  public userPrimaryLang: string;
  public userSecondaryLang: string;
  public CONFIG = Config;
  public user: User;
  public document: Document;
  public DIRECTION: Direction;//used for dialogs
  public title: Title;
  public showChangePass: boolean = false;
  constructor() {
    this.translatePipe = ServiceLocator.injector.get(TranslatePipe);
    this.util = ServiceLocator.injector.get(Util);
    this.translationService = ServiceLocator.injector.get(TranslationService);
    this.authorizationService = ServiceLocator.injector.get(AuthorizationService);
    this.document = ServiceLocator.injector.get(DOCUMENT);
    this.userLocale = this.translationService.getLocale();
    this.direction = this.translationService.getDirection();
    this.userPrimaryLang = this.translationService.getPrimaryLang();
    this.userSecondaryLang = this.translationService.getSecondaryLang();
    this.title = ServiceLocator.injector.get(Title);

    this.authorizationService.user.subscribe(user => {
      this.user = user;
      this.showChangePass = this.user?.Privileges?.includes(Right.SSO)
    });
    this.translationService.userLocaleSubject.subscribe(locale => {
      this.userLocale = locale;
      this.document.documentElement.lang = locale === "en_us" ? "en" : "ar";
      if (this.translationService.getTranslations()["websiteName"]) {//set title
        this.title.setTitle(this.translatePipe.getLabel("websiteName"));
      }
    });
    this.translationService.userPrimaryLangSubject.subscribe(lang => {
      this.userPrimaryLang = lang;
    });
    this.translationService.userSecondaryLangSubject.subscribe(lang => {
      this.userSecondaryLang = lang;
    });
    this.translationService.directionSubject.subscribe(value => {
      this.direction = value;
      this.DIRECTION = this.direction === "ltr" ? "ltr" : "rtl";
      this.document.documentElement.dir = value;
    });
  }

  getErrorMessage(formControl: AbstractControl) {
    return this.util.getErrorMessage(formControl);
  }

  dateFromToValidation(fromControlName: string, toControlName: string) {
    return (group: FormGroup): { [key: string]: any } => {
      let fromDate: AbstractControl = group.controls[fromControlName];
      let toDate: AbstractControl = group.controls[toControlName];
      if (fromDate && fromDate.value && toDate && toDate.value && (fromDate.value > toDate.value || toDate.value < fromDate.value)) {
        let error = { 'invalidDate': true };
        fromDate.setErrors(error);
        return error;
      } else {
        return null;
      }
    }
  }

}
